<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="banner.banner_img"
        alt=""
      >
      <div class="Title">
        {{banner.banner_name_cn}}
        <p>{{banner.banner_name_en}}</p>
      </div>

    </div>
    <div class="nav">
      <ul>
        <li
          :class="navId==i?'li active':'li'"
          v-for="(item,i) of configData.navbar"
          :key="i"
          @click="navClick(i)"
        >
          {{item}}
        </li>
      </ul>
    </div>
    <section
      class="section1"
      v-if="navId==0"
      v-html="configData.summary.summary_content_cn"
    >
    </section>
    <section
      class="section2"
      v-else
    >
      <ul class="list">
        <li
          class="li"
          v-for="(item,i) of teacherList"
          :key="i"
          @click="detailClick(item)"
        >
          <img
            class="img"
            :src="item.team_img"
            alt=""
          >
          <div class="liCon ">
            <p class="name ellipsis" :title="item.team_name_cn">
              {{item.team_name_cn}}
            </p>
            <!-- <p class="time">{{item.creat_time}}</p> -->
          </div>
        </li>
      </ul>
      <el-pagination
        :background="true"
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :total="total"
        class="page"
        :current-page="page"
        @current-change="changePage"
        :page-size='9'
      >
      </el-pagination>
    </section>
  </div>
</template>
<script>
import { teacherConfigData, getBanner,teacherTeamList } from "../../api/home";
export default {
  name: "TeacherTeam",
  data() {
    return {
      warmNav: [
        {
          name: "教师团队总体概述",
          id: 0
        },
        {
          name: "部分名师介绍",
          id: 1
        }
      ],
      navId: 0,
      page: 1,
      banner: {},
      configData: { summary: {}, navbar: [] }, //教师团队概述
      teacherList:[],//名师列表
      total:1,
    };
  },
  methods: {
    navClick(item) {
      this.navId = item;
      // this.page = 1;
      //   console.log(this.page);
      this.teacherTeamLists()
    },
    changePage(val) {
      this.page = val;
      this.teacherTeamLists()
    },
    // 名师列表
    teacherTeamLists(){
      teacherTeamList({
        per_page:9,
        page:this.page,
      }).then(res=>{
        // console.log(res.data)
        this.teacherList=res.data.list
        this.total=res.data.count
      })
    },
    // 详情
    detailClick(item){
      var laber=[0,32,18]
      var laPath=['/','TeacherTeam']
      var routeData=this.$router.resolve({
        path: "/TeacherDetail",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: item.team_id,
          type:2,
        }
      });
       window.open(routeData.href, "_blank");
    }
  },
  created() {
    getBanner({ address: 32 }).then(res => {
      this.banner = res.data;
    });
    teacherConfigData({}).then(res => {
      // console.log(res.data);
      this.configData = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  padding: 0.1px 0;
  background: rgba(255, 255, 255, 1);
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(129px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  p {
    margin-top: px2Rem(20px);
    font-size: px2Rem(40px);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  }
}
.nav {
  width: 100%;
  height: px2Rem(100px);
  margin-bottom: px2Rem(40px);
  background: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 9px 0px rgba(0, 0, 0, 0.3);
  line-height: px2Rem(100px);
  ul {
    width: px2Rem(1300px);
    height: 100%;
    margin: auto;
    .li {
      display: inline-block;
      position: relative;
      height: 100%;
      margin-right: px2Rem(80px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(120, 120, 120, 1);
      cursor: pointer;
      //   transition: 0.3s;
      &:last-of-type {
        margin-right: 0;
      }
      &::after {
        display: block;
        position: absolute;
        width: px2Rem(0px);
        height: 2px;
        content: "";
        transition: 0.3s;
        left: 50%;
        // bottom: 0;
        transform: translate(-50%, 0);
      }
      &:hover {
        &::after {
          display: block;
          content: "";
          position: absolute;
          width: px2Rem(110px);
          height: 2px;
          bottom: 0;
          background: rgba(28, 50, 120, 1);
          border-radius: 1px;
          transition: 0.3s;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
    }
    .active {
      font-size: px2Rem(34px);
      color: #333;
      &::after {
        display: block;
        content: "";
        position: absolute;
        width: px2Rem(110px);
        height: 2px;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        background: rgba(28, 50, 120, 1);
        border-radius: 1px;
      }
    }
  }
}
.section1 {
  // width: px2Rem(1300px);
  margin: auto;
  margin-bottom: px2Rem(125px);
  font-size: px2Rem(30px);
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: px2Rem(40px);
}
.section2 {
  width: px2Rem(1300px);
  margin: auto;
  margin-bottom: px2Rem(90px);
  .list {
    font-size: 0;
    .li {
      position: relative;
      display: inline-block;
      width: px2Rem(400px);
      height: px2Rem(325px);
      top: 0;
      margin-right: px2Rem(48px);
      margin-bottom: px2Rem(20px);
      vertical-align: top;
      cursor: pointer;
      transition: 0.3s;
      overflow: hidden;
      &:nth-of-type(3n) {
        margin-right: px2Rem(0px);
      }
      &:hover {
        top: px2Rem(-10px);
        box-shadow: 3px 3px 9px 0px rgba(0, 0, 0, 0.3);
        .img {
          transform: scale(1.1);
        }
      }
      .img {
        display: block;
        width: 100%;
        height: px2Rem(245px);
        transition: 0.5s;
      }
      .liCon {
        padding: px2Rem(20px);
        // transition: 0.3s;
        .name {
          margin-bottom: px2Rem(10px);
          font-size: px2Rem(30px);
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .time {
          font-size: px2Rem(20px);
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
    }
  }
}
.page {
  margin-top: px2Rem(40px);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/ManagementTeam/TeacherTeam.vue